import React from 'react';
import { useAuth } from '../Context/AuthContext';
import { Navigate } from 'react-router-dom';

// El 'children' es el componente público (ej. Login)
function PublicOnlyRoute({ children }) {
  const { session, loading } = useAuth();

  if (loading) {
    return <div>Cargando...</div>;
  }

  // Si SÍ hay sesión (está logueado), lo mandamos al dashboard
  if (session) {
    return <Navigate to="/dashboard" replace />;
  }

  // Si no hay sesión, mostramos el componente (Login)
  return children;
}

export default PublicOnlyRoute;